"use client";
import React, { useState } from "react";
import {
  Box,
  Flex,
  Input,
  IconButton,
  Heading,
  InputGroup,
  InputRightElement,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Button,
} from "@chakra-ui/react";
import { SearchIcon, ChevronDownIcon } from "@chakra-ui/icons";

interface SalesTeamHeaderProps {
  onSearch: (query: string) => void;
  onProjectFilter: (project: string) => void;
  availableProjects: string[];
  hideProjectFilter?: boolean;
}

export function SalesTeamHeader({ onSearch, onProjectFilter, availableProjects = [], hideProjectFilter = false }: SalesTeamHeaderProps) {
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedProject, setSelectedProject] = useState("All Projects");

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    onSearch(searchQuery);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchQuery(value);
    onSearch(value); // Real-time search
  };

  const handleProjectSelect = (project: string) => {
    setSelectedProject(project);
    onProjectFilter(project);
  };

  return (
    <Box as="header" px={8} py={6} bg="white" borderBottomWidth="1px">
      <Flex justify="space-between" align="center">
        <Heading
          as="h1"
          fontSize="32px"
          fontWeight="600"
          color="gray.800"
        >
          SALES TEAM
        </Heading>
        <Flex>
          {!hideProjectFilter && (
            <Menu>
              <MenuButton 
                as={Button} 
                rightIcon={<ChevronDownIcon />}
                bg="white"
                borderWidth="1px"
                borderColor="gray.200"
                _hover={{ bg: "gray.50" }}
                _active={{ bg: "gray.50" }}
                mr={3}
                width="170px"
                textAlign="left"
                fontSize="sm"
              >
                {selectedProject}
              </MenuButton>
              <MenuList maxH="300px" overflowY="auto">
                <MenuItem onClick={() => handleProjectSelect("All Projects")}>
                  All Projects
                </MenuItem>
                {availableProjects.map((project, index) => (
                  <MenuItem key={index} onClick={() => handleProjectSelect(project)}>
                    {project}
                  </MenuItem>
                ))}
              </MenuList>
            </Menu>
          )}
        <form onSubmit={handleSearch}>
          <InputGroup size="md" width="280px">
            <Input
              placeholder="Search"
              value={searchQuery}
              onChange={handleChange}
              borderRightRadius="0"
              _focus={{
                borderColor: "purple.600",
                boxShadow: "none",
              }}
            />
            <InputRightElement width="48px">
              <IconButton
                aria-label="Search"
                icon={<SearchIcon />}
                size="sm"
                type="submit"
                colorScheme="purple"
                borderLeftRadius="0"
                width="100%"
                height="38px"
              />
            </InputRightElement>
          </InputGroup>
        </form>
        </Flex>
      </Flex>
    </Box>
  );
} 